import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
    { path: "", redirectTo: "/backoffice", pathMatch: "full" },
    {
        path: "login",
        title: "מכללת גל | כניסה",
        loadComponent: () => import("./core/auth/login/login"),
    },
    {
        path: "signup",
        title: "מכללת גל | הרשמה",
        loadComponent: () => import("./core/auth/signup/signup"),
    },
    {
        path: "backoffice",
        canActivate: [authGuard],
        loadChildren: () => import("./backoffice/backoffice.routes"),
    },
    {
        path: "q/:token",
        title: "מכללת גל | שאלון",
        loadComponent: () => import("./questionnaire/questionnaire").then(m => m.default)
    },
    {
        path: "questionnaire/:templateId/:applicantId",
        canActivate: [authGuard],
        title: "מכללת גל | שאלון",
        loadComponent: () => import("./questionnaire/questionnaire").then(m => m.default)
    },
    {
        path: "**",
        loadComponent: () => import("./core/not-found/not-found"),
        title: "מכללת גל | דף לא נמצא",
    },
];
